<template>
  <div v-if="selectedBenefit">
    <BenefitShow :benefit="selectedBenefit" :key="selectedBenefit.id" :types="selectedBenefit.types" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BenefitShow from "@/components/Benefits/BenefitShow";
export default {
  components: {
    BenefitShow
  },
  data() {
    return {
      watchRoute: true
    }
  },
  watch:{
    // $route (to, from){
    //   let id = this.$route.params.id;

    //   if (this.watchRoute) {
    //     this.fetchBenefit({id: id, full_legal_number: localStorage.getItem("view_as")});
    //   }
    // }
  },
  beforeRouteUpdate (to, from, next) {
    
    if (this.watchRoute) {
      this.fetchBenefit({id: to.params.id, full_legal_number: localStorage.getItem("view_as")});
    }
    next();
  },
  computed: {
    ...mapState("benefits", ["selectedBenefit"]),
  },
  methods:{
    ...mapActions("benefits",["fetchBenefit"])
  },
  mounted() {
    let benefitId = this.$route.params.id;
    this.fetchBenefit({id: benefitId, full_legal_number: localStorage.getItem("view_as")});
  }
};
</script>
